
























































import Vue from 'vue';
import { IVoucherAssignmentCustomerData } from '../../../common/interfaces/shared.interface';
import CustomButton from '../../layout/buttons/CustomButton.vue';
import { IIcons } from '../../../common/interfaces/index.interface';
import TIcons from '../../../types/TIcons';

interface IVoucherAssignmentSuccessfulNoticeComponent {
  icons: IIcons;
}

export default Vue.extend({
  name: `VoucherAssignmentSuccessfulNotice`,
  components: { CustomButton },
  data(): IVoucherAssignmentSuccessfulNoticeComponent {
    return {
      icons: TIcons,
    };
  },
  props: {
    customer: {
      required: true,
      type: Object as () => IVoucherAssignmentCustomerData,
    },
    sendEmailLoading: {
      default: false,
      type: Boolean,
    },
  },
});
